
  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.button = this.querySelector('button.localize-btn');
        // this.panel = this.querySelector('.localize-options'); 
        this.links = this.querySelectorAll('a[data-value]');
        this.input = this.querySelector('input[name="language_code"]');

        this.button.addEventListener('click', this.togglePanel.bind(this));
        this.links.forEach(link => link.addEventListener('click', this.onLinkClick.bind(this)));

        // Đóng dropdown khi click ra ngoài
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) {
            this.hidePanel();
          }
        });
      }

      togglePanel(event) {
        event.preventDefault();
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          this.hidePanel();
        } else {
          this.showPanel();
        }
      }

      showPanel() {
        this.button.setAttribute('aria-expanded', 'true');
      }

      hidePanel() {
        this.button.setAttribute('aria-expanded', 'false');
      }

      onLinkClick(event) {
        event.preventDefault();
        this.input.value = event.currentTarget.dataset.value;
        if (this.form) {
          this.form.submit();
        }
      }
    });
  }
